import type { LayoutVariables } from '../types';
import { ReactComponent as Logo } from './assets/images/oorcheck-logo.svg';

const layoutVariables: LayoutVariables = {
  logo: {
    LogoSVG: Logo,
  },
  basicPage: {
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  homePage: {
    heroImageRatioXS: '9_16',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '4_3',
    heroImageRatioLG: '3_2',
    heroImageRatioXL: '16_9',
    heroTextColClasses: 'col-12 col-md-10 col-lg-9',
    heroButtonColClasses: 'col-12 col-lg-3',
    heroQuicklinksColClasses: 'col-12',
    quickLinksButtonType: 'secondary',
  },
  landingPage: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '3_1',
    heroImageRatioXL: '3_1',
    heroTextColClasses: 'col-12 col-lg-9 offset-lg-2',
    heroImageColClasses: 'col-12',
  },
  overviewPage: {
    breadcrumbsColClasses: 'col-12 col-md-10 col-lg-9',
    heroTextColClasses: 'col-12 col-md-10 col-lg-9',
  },
  profilePage: {
    heroImageRatioXS: '4_3',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '3_4',
    heroImageRatioLG: '3_4',
    heroImageRatioXL: '1_1',
    breadcrumbsColClasses: 'col-12',
    heroImageColClasses: 'col-12 col-md-5',
    heroDetailsColClasses: 'col-12 col-md-7',
    bodyBelowHero: true,
    // Only used if bodyBelowHero is true.
    heroBodyColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  profileTeaser: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
  },
  article: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-9 offset-lg-0',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-9 offset-lg-0',
    heroImageColClasses: 'col-full col-md-12',
  },
  articleTeaser: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '4_3',
    heroImageRatioXL: '4_3',
  },
  project: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    breadcrumbsColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroTextColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    heroImageColClasses: 'col-full col-md-12 col-lg-10 offset-lg-1',
  },
  themeParent: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '2_1',
    heroImageRatioLG: '2_1',
    heroImageRatioXL: '2_1',
    heroTextColClasses: 'col-8 offset-2 col-lg-6 offset-lg-3',
    heroMediaColClasses: 'col-full',
    textColClasses: 'col-12 col-lg-8 offset-lg-2',
    searchThemesColClasses: 'col-12 col-lg-8 offset-lg-2',
  },
  themeChild: {
    heroImageRatioXS: '16_9',
    heroImageRatioSM: '16_9',
    heroImageRatioMD: '16_9',
    heroImageRatioLG: '16_9',
    heroImageRatioXL: '16_9',
    heroTextColClasses: 'col-12 col-lg-8 offset-lg-2',
    heroMediaColClasses: 'col-12',
    textColClasses: 'col-12 col-lg-8 offset-lg-2',
    searchThemesColClasses: 'col-12 col-lg-8 offset-lg-2',
  },
  projectTeaser: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '1_1',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '4_3',
    heroImageRatioXL: '4_3',
  },
  paragraphTextMedia: {
    forceTopAlignmentVideoAudio: true,
    alignmentTopImageRatioXS: '16_9',
    alignmentTopImageRatioSM: '16_9',
    alignmentTopImageRatioMD: '16_9',
    alignmentTopImageRatioLG: '16_9',
    alignmentTopImageRatioXL: '16_9',
    alignmentLeftRightImageRatioXS: '1_1',
    alignmentLeftRightImageRatioSM: '16_9',
    alignmentLeftRightImageRatioMD: '16_9',
    alignmentLeftRightImageRatioLG: '1_1',
    alignmentLeftRightImageRatioXL: '1_1',
    mediaColClasses: 'col-12 col-lg-6 order-1',
    mediaColClassesAlignmentRight: '',
    mediaColClassesAlignmentTop: 'col-12 col-lg-8 offset-lg-2',
    textColClasses: 'col-12 col-lg-6 order-2',
    textColClassesAlignmentLeft: '',
    textColClassesAlignmentTop: 'col-lg-8 offset-lg-2',
  },
  paragraphHtmlEmbed: {
    contentColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  paragraphLinkList: {
    imageRatio: '16_9',
    bodyColClasses: 'col-12',
    linksColClasses: 'col-12',
  },
  paragraphMetrics: {
    paragraphSingle: 'col-12 col-lg-8 offset-lg-2',
    paragraphMultiple: 'col-12',
    headerSingle: 'col-12 col-lg-8 offset-lg-2',
    headerMultiple: 'col-12 col-lg-8 offset-lg-2',
  },
  paragraphQuote: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '1_1',
    heroImageRatioLG: '1_1',
    heroImageRatioXL: '1_1',
    imageColClasses: 'col-full col-md-6 col-lg-5',
    imageColClassesAlignmentRight: '',
    textColClassesWithImage: 'col-12 col-md-6 col-lg-7',
    textColClassesWithImageAlignmentLeft: '',
    textColClassesWithoutImage: 'col-md-10 offset-md-1 col-lg-8 offset-lg-2',
  },
  paragraphFAQ: {
    textColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    textColClassesHorizontal: 'col-12 col-md-10 offset-md-1 col-lg-3 offset-lg-2',
    faqColClasses: 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2',
    faqColClassesHorizontal: 'col-12 col-md-10 offset-md-1 col-lg-5',
  },
  paragraphWebform: {
    textColClasses: 'col-12 col-lg-10 offset-lg-1',
    webformColClasses: 'col-12 col-lg-10 offset-lg-1',
  },
  blockCTA: {
    heroImageRatioXS: '1_1',
    heroImageRatioSM: '4_3',
    heroImageRatioMD: '4_3',
    heroImageRatioLG: '4_3',
    heroImageRatioXL: '4_3',
    backgroundImageRatio: '2_1',
    imageColClasses: 'col-12 col-lg-auto order-1',
    textColClasses: 'col-12 col-lg',
    backgroundTextColClasses: 'col-12',
  },
  searchPage: {
    hitsPerPage: 8,
    textColClasses: 'col-12 col-lg-8 offset-lg-2',
    facetColClasses: 'col-12 col-lg-4',
    resultsColClasses: 'col-12 col-lg-8 offset-lg-2',
  },
  footer: {
    footerLogoColClasses: 'col-12',
    footerMainSectionColClasses: 'col-12',
    footerContactBlockColClasses: 'col-12 col-lg-3',
  },
};

export default layoutVariables;
